import { useContext, useMemo } from "react";
import { CandidateContext } from "../../../CandidateProfile";
import { Grid, Typography } from "@mui/material";

export default function CustomData() {
  const { candidate } = useContext(CandidateContext);

  const candidateFields = useMemo(() => {
    const newFields = new Map<string, string[]>();

    candidate.fields?.forEach((c) => {
      newFields.set(c.label, [...new Set((newFields.get(c.label) ?? [])?.concat(c.value))].sort());
    });

    return newFields;
  }, [candidate]);

  return (
    <Grid container rowSpacing={2}>
      {candidateFields && candidateFields.size > 0 ? (
        [...candidateFields.keys()].sort().map((c: string) => {
          return (
            <>
              <Grid item xs={6}>
                <Typography fontWeight={600}>{c}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography style={{ wordBreak: "break-word" }}>
                  {candidateFields.get(c)?.join(", ")}
                </Typography>
              </Grid>
            </>
          );
        })
      ) : (
        <>No custom data found.</>
      )}
    </Grid>
  );
}
